import React from "react";
import AddToBasketContainer from "../containers/add_to_basket";

const Products = (props) => {

  const grouppedProducts = () => {
    const GROUP_SIZE = props.productColumns;
    return props.products
      .map((product, index) =>
        index % GROUP_SIZE === 0
          ? props.products.slice(index, index + GROUP_SIZE)
          : null
      )
      .filter(e => e);
  }

  const renderProductDescriptions = (product) => {
    return product.descriptions.map((description, index) => {
      if (index === 0) {
        return (
          <h3
            className="product__description product__description--large"
            key={`description_${index}`}
          >
            {description}
          </h3>
        );
      } else {
        return (
          <p
            className="product__description product__description--small"
            key={`description_${index}`}
          >
            {description}
          </p>
        );
      }
    });
  }

  const renderDownloadOption = (label, downloadPath, product) => {
    const href = encodeURI(`${downloadPath}?product_ids[]=${product.id}`);

    return (
      <li>
        <a className="dropdown-item" href={href} onClick={props.onDownloadClick}>
          {label}
        </a>
      </li>
    );
  }

  const renderDownloadAllOption = (product) => {
    const {
      availableDownloadOptions,
      downloadPaths,
      translations
    } = props;

    if (!availableDownloadOptions.all) {
      return null;
    }

    return renderDownloadOption(
      translations.download_all_materials,
      downloadPaths.all,
      product
    );
  }

  const renderDownloadSpecsOption = (product) => {
    const {
      availableDownloadOptions,
      downloadPaths,
      translations
    } = props;

    if (!availableDownloadOptions.specs) {
      return null;
    }

    return renderDownloadOption(
      translations.download_specs,
      downloadPaths.specs,
      product
    );
  }

  const renderDownloadRevitOption = (product) => {
    const {
      availableDownloadOptions,
      downloadPaths,
      translations
    } = props;

    if (!availableDownloadOptions.revit) {
      return null;
    }

    return renderDownloadOption(
      translations.download_revit,
      downloadPaths.revit,
      product
    );
  }

  const renderProductMenu = (product) => {
    const productHref = product.productUrl
      ? product.productUrl
      : `${props.productsPath}/${product.id}`;
    const productTarget = product.productUrl ? "_blank" : "_self";
    const anyUrlOptions = product.urlOptions.length > 0;
    const {
      availableDownloadOptions,
      showLinkToProductPageInProductMenu
    } = props;
    const anyDownloadOptions =
      availableDownloadOptions.any ||
      availableDownloadOptions.specs ||
      availableDownloadOptions.revit;
    return (
      <div className="dropup">
        <div
          className="dropdown-toggle"
          data-bs-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
        >
          <div className="product__menu-wrapper d-none d-md-block">
            {renderProductDescriptions(product)}
            <i className="product__menu-icon fa fa-ellipsis-h" />
          </div>
          <div className="product__menu-wrapper d-md-none">
            <i className="product__menu-icon fa fa-ellipsis-h" />
            <br />
            {renderProductDescriptions(product)}
          </div>
        </div>
        <ul className="dropdown-menu">
          {product.urlOptions.map(option => (
            <li key={`urlOption_${option.label}`}>
              <a className="dropdown-item" href={option.href}>{option.label}</a>
            </li>
          ))}
          {anyUrlOptions && <li className="dropdown-divider" />}
          {renderDownloadAllOption(product)}
          {renderDownloadSpecsOption(product)}
          {renderDownloadRevitOption(product)}
          {anyDownloadOptions && showLinkToProductPageInProductMenu && (
            <li className="dropdown-divider" />
          )}
          {showLinkToProductPageInProductMenu && (
            <li>
              <a className="dropdown-item" href={productHref} target={productTarget}>
                Go to product page
              </a>
            </li>
          )}
        </ul>
      </div>
    );
  }

  const renderProductPhoto = (product) => {
    if (product.thumbnailPhotoUrl) {
      return (
        <div
          className="product__photo"
          onClick={e => props.onProductPhotoClick(product.id)}
          style={{ backgroundImage: `url('${product.thumbnailPhotoUrl}')` }}
        >
        </div>
      );
    } else {
      return null;
    }
  }

  const renderProductCheckbox = (product) => {
    const { translations } = props;

    if (product.journalId) {
      const checked = props.selectedProductIds.indexOf(product.id) >= 0;
      return (
        <input
          type="checkbox"
          className="product__checkbox"
          checked={checked}
          title={translations.checkbox_tooltip}
          onChange={e => props.onProductPhotoClick(product.id)}
        />
      );
    } else {
      return null;
    }
  }

  const renderGrid = (downloadsAvailable) => {
    const { productColumns } = props;
    const cssColumnsCount = Math.floor(12 / productColumns);

    return grouppedProducts().map((group, index) => (
      <div className="row" key={`product_group_${index}`}>
        {group.map(product => (
          <div
            className={`col-${cssColumnsCount}`}
            key={product.id}
          >
            <div className="product__wrapper">
              <div className="product__photo-wrapper">
                {renderProductPhoto(product)}
                {downloadsAvailable && renderProductCheckbox(product)}
                {downloadsAvailable && <AddToBasketContainer productId={product.id} />}
              </div>
              <div className="product__data">
                {renderProductMenu(product)}
              </div>
            </div>
          </div>
        ))}
      </div>
    ));
  }

  const renderList = (downloadsAvailable) => {
    const { products, filter } = props;
    return products.map(product => (
      <div
        className="product__wrapper product__wrapper--list"
        key={`product_${product.id}`}
      >
        <div className="product__photo-wrapper product__photo-wrapper--list">
          {renderProductPhoto(product)}
          {downloadsAvailable && renderProductCheckbox(product)}
          {downloadsAvailable && <AddToBasketContainer productId={product.id} />}
        </div>
        <div className="product__data product__data--list">
          {renderProductMenu(product)}
        </div>
      </div>
    ));
  }

  const { availableDownloadOptions } = props;
  const downloadsAvailable =
    availableDownloadOptions.all ||
    availableDownloadOptions.specs ||
    availableDownloadOptions.revit;

  switch (props.viewMode) {
    case "grid":
      return renderGrid(downloadsAvailable);
    case "list":
      return renderList(downloadsAvailable);
  }
}

export default Products;